<div class="t-popup popup-patientDetails">

		<div class="t-popup-close"></div>
		
		<div class="t-popup-frame">
			<div class="t-popup-body">

				<button class="t-btn-popup-close" aria-label="close popup" (click)="close(true)"></button>

				<h2>
					Patient Details Form
				</h2>
				<!-- box (end) -->

				<div class="l-flex l-flex-w t-fieldmargin patient-details">
					
					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<div class="t-field l-flex t-twin-fieldset">
								<label style='width: 3em'>
									<input checked type="radio" name="id" [(ngModel)]="myPat.IsID" [value]="1" class="custom-check customInput" aria-labelledby="pregnancy_popup-anomales" >
                                    <i class="customInput-display"></i>
                                    <span>
										ID
									</span>
								</label>
								<label style='width: 4em'>
									<input type="radio" name="id" [(ngModel)]="myPat.IsID" [value]="0" class="custom-check customInput" aria-labelledby="pregnancy_popup-anomales">
                                    <i class="customInput-display"></i>
                                    <span>
										Pass
									</span>
								</label>
							</div>

							<i class="t-sep"></i>

							<div class="t-validation-wrap">
								<input type="text" [(ngModel)]="myPat.ID" class="t-field-text w100" (keyup)="clearSpace()" [ngClass]="IDValidator() && ! iderr? '': 'is-invalid'" (change)="idchanged=true"/>
								<div class="t-validation-message">
									<span>{{iderr? iderr : 'Invalid ID Number'}}</span>
								</div>
							</div>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								First Name
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.First" class="t-field-text w100" (change)="idchanged=true"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Last Name
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.Last" class="t-field-text w100" (change)="idchanged=true"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<div class="w33">
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								First Name Eng.
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.FirstEng" class="t-field-text w100" (change)="idchanged=true"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Last Name Eng.
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.LastEng" class="t-field-text w100" (change)="idchanged=true"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->
					

					

					<!-- cell ( start ) -->
					<div class="w33" [ngClass]="myPat.Height && myPat.Weight? 'smallbox':''" (change)="myPat.BSAus=null">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Height
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<span class="t-field t-field--number">
									<input [(ngModel)]="myPat.Height" class="t-field-text" type="number" min="0">
									<span class="t-field-desc">
										cm
									</span>
								</span>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->					

					<!-- cell ( start ) -->
					<div class="w33" [ngClass]="myPat.Height && myPat.Weight? 'smallbox':''">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Weight
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<span class="t-field t-field--number">
									<input [(ngModel)]="myPat.Weight" class="t-field-text" type="number" min="0" (change)="myPat.BSAus=null">
									<span class="t-field-desc">
										kg
									</span>
								</span>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->
					
					<div class="w33 smallbox" *ngIf="myPat.Weight && myPat.Height">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								BMI
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<span class="t-field t-field--number">
									{{getBMI()}}
								</span>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<div class="w33 smallbox" *ngIf="ls.isCardio && myPat.Weight && myPat.Height">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label [matTooltip]="myPat.BSAus ? 'From Ultrasound': 'Calculated'" [ngClass]="myPat.BSAus ? 'red':''">
								BSA
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<span class="t-field t-field--number">
									{{getBSA()}}
								</span>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

						<!-- cell ( start ) -->
					<div class="w33">

							<div class="l-flex l-flex-c t-field t-field-pad">
	
								<label>
									Birth Date
								</label>
	
								<i class="t-sep"></i>
	
								<span class="t-validation-wrap l-fg1">
									<input [(ngModel)]="Birth"  (dateChange)="dateChanged('Birth')"  [matDatepicker]="birthpicker" [max]="maxBD"  class="t-field-text w100"/>
									<img src="../../assets/icons/date.svg" (click)="birthpicker.open()" style='margin-left: -1.8em;position:absolute'>
									<mat-datepicker #birthpicker [startAt]="startBD" startView="year"></mat-datepicker>
								</span>
								
							</div>
							
						</div>
						<!-- cell ( end ) -->
					<!-- cell ( start ) -->
					<div class="w33" *ngIf="ls.isCardio || ls.isGastro">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Sex
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<select class="t-select w100" [(ngModel)]="myPat.Sex">
									<option value=""></option>
                                    <option value="M">Male</option>
                                    <option value="F">Female</option>
								</select>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Email
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="email" [(ngModel)]="myPat.Email" class="t-field-text w100"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Mobile
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="tel" [(ngModel)]="myPat.Mobile" class="t-field-text w100"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Phone
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="tel" [(ngModel)]="myPat.Phone" class="t-field-text w100"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Address
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.Address" class="t-field-text w100"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Town
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.City" class="t-field-text w100"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Zip Code
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.Zip" class="t-field-text w100"/>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Blood Type
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<select class="t-select w100" [(ngModel)]="myPat.BloodType">
									<option value="">Select</option>
                                    <option value="A+">A+</option>
                                    <option value="B+">B+</option>
                                    <option value="AB+">AB+</option>
									<option value="O+">O+</option>
									<option value="A-">A-</option>
                                    <option value="B-">B-</option>
                                    <option value="AB-">AB-</option>
                                    <option value="O-">O-</option>
								</select>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Health Provider
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<select class="t-select w100" [(ngModel)]="myPat.HMO" (change)="idchanged=true">
									<option value="">Select</option>
									<option value="Clalit">Clalit</option>
									<option value="Macabi">Macabi</option>
									<option value="Meuhedet">Meuhedet</option>
									<option value="Leumit">Leumit</option>
									<option value="Private">Private</option>
									<option *ngIf="ls.isCardio" value="IDF">IDF</option>

								</select>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<!-- <div class="w33">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
							שם רופא מפנה  
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.RefferDoc" class="t-field-text w100" (change)="idchanged=true"/>
							</span>
							
						</div>
						
					</div> -->
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w33" *ngIf="myPat.PID && ls.separatedClinic && (ls.isAdmin || ls.userType == 'secretary')">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
							<img src="../../assets/icons/drb.svg">
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								{{ls.getDocByUID(myPat.UID)}}
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->
					<div class="w33" *ngIf="! tryCopy && myPat.PID && ls.separatedClinic && (ls.isAdmin || ls.userType == 'secretary')">
						
						<div class="l-flex l-flex-c t-field t-field-pad">
							<button class="search-btn" style="max-width: 3.5em" [disabled]="copyTo? false: 'disabled'" (click)="copyPat()">
								Copy
							</button>
							to
							<select [(ngModel)]="copyTo" class="t-select w100" style="text-align: center;" (change)="idchanged=true">
								<ng-container *ngFor="let e of ls.clinicUsers">
									<option [value]="e.UID" *ngIf="e.UID != myPat.UID">{{e.Name}}</option>
								</ng-container>
							</select>
							
						</div>
						
					</div>
					<div class="w33" *ngIf="copyNote">
						{{copyNote}}
					</div>
					<!-- cell ( end ) -->

					<!-- cell ( start ) -->
					<div class="w100">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Comments
							</label>

							<span class="t-validation-wrap is-sep l-fg1">
								<textarea [(ngModel)]="myPat.Comments" class="t-field-text w100"></textarea>
							</span>
							
						</div>
						
					</div>
					<!-- cell ( end ) -->

				</div>

				<button class="new_save" (click)="savePatient()" [ngClass]="(! openAWL && ! awl) || ls.isCardio ? 'awlopen':''"  matTooltip="שמור פרטי נבדק/ת" *ngIf="! hideSave && ! ls.barcodeScan">
					Save Patient Details {{myPat.PID ? '': 'and Close'}}
				</button>
				<button class="new_save" (click)="prepareAWL()" *ngIf="! openAWL && ! awl && !ls.ishospital && ! hideSave" style="max-width: 17em;top: -4.3em;position:relative; float:right;margin-bottom: -3em">
					Add to TodayList
				</button>
				<button class="new_save openAWL" (click)="showpay.next(undefined)" *ngIf="awl && myPat.HMO == 'Macabi' && ls.isCardio" style="position: relative;margin-top: -3.5em;">הצג זכאות</button>
				<button class="new_save openAWL" (click)="receive()" *ngIf="awl && myPat.HMO != 'Macabi' && ls.isCardio && myPat.Status == 'Waiting'" style="position: relative;margin-top: -3.5em;">קבלה</button>
				
				<h2 *ngIf="awl || openAWL" style='margin-top: 1em'>
					TodayList Details
				</h2>
				<!-- box (end) -->

				<div class="l-flex l-flex-w t-fieldmargin patient-details" *ngIf="(awl || openAWL) ">
					<div class="flex w100">
					<div >

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label class="w50" matTooltip="מועד הבדיקה">
								Time
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1 w50">
								<input type="time" [(ngModel)]="awlTime" class="t-field-text w100"/>
							</span>
							
						</div>
						
					</div>
					<div >

						<div class="l-flex l-flex-c t-field t-field-pad" >

							<label matTooltip="סוג בדיקה">
								Exam Type
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<select [(ngModel)]="awlExam" class="t-select w100" (ngModelChange)="showSecondCommitmentDetails=false;rebootCommitment()">
									<option></option>
									<!-- <option *ngIf="awlExam && ! examTypes.includes(awlExam)" [value]="awlExam">{{awlExam}}</option> -->
									<ng-container *ngFor="let e of getExamTypes()">
										<option [value]="e">{{e}}</option>
									</ng-container>
								</select>
							</span>
							
						</div>
						
					</div>
				</div>

					<div class="w100 flex" *ngIf="myPat.HMO == 'Macabi' || myPat.HMO == 'Leumit' || myPat.HMO == 'Meuhedet' || myPat.HMO == 'Clalit'">
					<div class="l-flex l-flex-c t-field t-field-pad" style="display: flex;flex-direction: column;" [ngClass]="(myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit') && (awlExam === 'Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo')? 'firstPrn': '' " [ngStyle]="((awlExam === 'Gastro-Colonoscopy'  || awlExam === 'Gastro-Sigmo') && !showSecondCommitmentDetails && (myPat.HMO=='Clalit' || myPat.HMO=='Leumit')) ? {'border': '1px solid black'} : {}" 
						(click)="switchDetails(false)">
							<div style="display: flex;
							flex-direction: row;
						">

							<label matTooltip="מס. התחייבות" *ngIf="myPat.HMO == 'Macabi' || myPat.HMO == 'Meuhedet'">
							מספר התחייבות  
							</label>
							<label matTooltip="מס. הפניה" *ngIf="myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit'" [ngStyle]="(awlExam === 'Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo') ? {'cursor': 'pointer'} : {}">
								{{awlExam=='Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo'? "קוד הזמנה/הפנייה לגסטרו":"קוד הזמנה/הפנייה " }} 
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1">
								<input  style="height: 100%;" type="number" [(ngModel)]="myPat.PRN" class="t-field-text w100" [ngClass]="prnerr? 'is-invalid':''"/>
								<div class="t-validation-message">
									<span>{{prnerr}}</span>
								</div>
							</span>
							
						</div>
					</div>
				<div class="l-flex l-flex-c t-field t-field-pad secondPrn" style="display: flex;flex-direction: column;" [ngStyle]="((awlExam === 'Gastro-Colonoscopy'  || awlExam === 'Gastro-Sigmo')&& showSecondCommitmentDetails && (myPat.HMO=='Clalit' || myPat.HMO=='Leumit')) ? {'border': '1px solid black'} : {}" 
					*ngIf="(awlExam=='Gastro-Colonoscopy'  || awlExam === 'Gastro-Sigmo')&& (myPat.HMO ==='Clalit' || myPat.HMO == 'Leumit')" (click)="switchDetails(true)">
						<div style="display: flex;
												flex-direction: row;" >
						
							
							<label matTooltip="מס. הפניה" *ngIf="(myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit') && awlExam=='Gastro-Colonoscopy'" style="cursor: pointer;" >
								קוד הזמנה/הפנייה לקולונו </label>
						
							<i *ngIf="awlExam=='Gastro-Colonoscopy'" class="t-sep"></i>
							<label  matTooltip="מס. הפניה" *ngIf="(myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit') && awlExam=='Gastro-Sigmo'" style="cursor: pointer;" >
								קוד הזמנה/הפנייה לסיגמו </label>
						
							<i *ngIf="awlExam=='Gastro-Sigmo'" class="t-sep"></i>
						
							<span class="t-validation-wrap l-fg1">
								<input type="number"  style="height: 100%;" [(ngModel)]="myPat.PRN2" class="t-field-text w100"  />
								<!-- [ngClass]="prnerr? 'is-invalid':''" -->
								<!-- <div class="t-validation-message">
								<span>{{prnerr}}</span>
							</div> -->
							</span>
						
						</div>
					</div>
					</div>
					<ng-container *ngIf="!showSecondCommitmentDetails" >
				<div class="w33" *ngIf="myPat.HMO == 'Macabi' || myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit'">
					
					<div class="l-flex l-flex-c t-field t-field-pad" [ngClass]="(myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit') && (awlExam === 'Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo')? 'firstPrn': '' " matTooltip=" רשיון רופא/זיהוי מזמין">
						<label *ngIf=" myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit'">
							רשיון רופא/זיהוי מזמין
						</label>
						<label *ngIf=" myPat.HMO == 'Macabi'">
							מס. רופא מפנה
						</label>
							
							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input  style="height: 100%;" type="number" [(ngModel)]="myPat.Code" class="t-field-text w100" [ngClass]="treatmenterr"/>
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					<div [ngClass]="myPat.HMO=='Macabi'? 'w50':'w33'" *ngIf="myPat.HMO == 'Macabi' || myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit'">
						
						<div class="l-flex l-flex-c t-field t-field-pad" [ngClass]="(myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit') && (awlExam === 'Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo')? 'firstPrn': '' " matTooltip="שם פרטי המזמין">
							<label  *ngIf="myPat.HMO == 'Macabi'">
								שם רופא מפנה
							</label>
							<label  *ngIf="myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit'">
								שם פרטי רופא מזמין
							</label>
							
							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.refDocName" class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					<div class="w33" *ngIf="myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit'">
						
						<div class="l-flex l-flex-c t-field t-field-pad " [ngClass]="(awlExam === 'Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo')? 'firstPrn': '' " matTooltip="שם משפחה המזמין">
							<label>
								 שם משפחה רופא מזמין
							</label>

							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.refDocLastName" class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					<div class="w33" *ngIf="myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit'">
						
						<div class="l-flex l-flex-c t-field t-field-pad " [ngClass]=" (awlExam === 'Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo')? 'firstPrn': '' " matTooltip=" קוד מרפאה">
							<label>
								  קוד מרפאה  
							</label>

							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="number" [(ngModel)]="myPat.BranchProviderID" class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					<div class="w33" *ngIf="myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit'">

						<div class="l-flex l-flex-c t-field t-field-pad " [ngClass]=" (awlExam === 'Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo')? 'firstPrn': '' " matTooltip="גורם שולח">
							
							<label>
									גורם שולח
								</label>
								
							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="text" [(ngModel)]="myPat.BranchProviderName" class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					</ng-container>
				<ng-container *ngIf="(myPat.HMO == 'Clalit' || myPat.HMO == 'Leumit')  && (awlExam=='Gastro-Colonoscopy' || awlExam === 'Gastro-Sigmo') && showSecondCommitmentDetails" >
						<div class="w33" >
							<div class="l-flex l-flex-c t-field t-field-pad secondPrn" matTooltip=" רשיון רופא/זיהוי מזמין">
								<label >
									רשיון רופא/זיהוי מזמין
								</label>
								
								
								<i class="t-sep"></i>
								<span class="t-validation-wrap l-fg1">
									<input  style="height: 100%;" type="number" [(ngModel)]="myPat.Code2" class="t-field-text w100" [ngClass]="treatmenterr"/>
									<div class="t-validation-message">
										<span>Invalid Doctor ID</span>
									</div>
								</span>
								
							</div>
							
						</div>
						<div class="w33" >
							
							<div class="l-flex l-flex-c t-field t-field-pad secondPrn"  matTooltip="שם פרטי המזמין">
								<label>
									שם פרטי רופא מזמין 
								</label>
								
								<i class="t-sep"></i>
								<span class="t-validation-wrap l-fg1">
									<input type="text" [(ngModel)]="myPat.refDocName2" class="t-field-text w100" />
									<div class="t-validation-message">
										<span>Invalid Doctor ID</span>
									</div>
								</span>
								
							</div>
							
						</div>
						<div class="w33">
							
							<div class="l-flex l-flex-c t-field t-field-pad secondPrn" matTooltip="שם משפחה המזמין">
								<label>
									 שם משפחה רופא מזמין
								</label>
	
								<i class="t-sep"></i>
								<span class="t-validation-wrap l-fg1">
									<input type="text" [(ngModel)]="myPat.refDocLastName2" class="t-field-text w100" />
									<div class="t-validation-message">
										<span>Invalid Doctor ID</span>
									</div>
								</span>
								
							</div>
							
						</div>
						<div class="w33" >
							
							<div class="l-flex l-flex-c t-field t-field-pad secondPrn" matTooltip=" קוד מרפאה">
								<label>
									  קוד מרפאה  
								</label>
	
								<i class="t-sep"></i>
								<span class="t-validation-wrap l-fg1">
									<input type="number" [(ngModel)]="myPat.BranchProviderID2" class="t-field-text w100" />
									<div class="t-validation-message">
										<span>Invalid Doctor ID</span>
									</div>
								</span>
								
							</div>
							
						</div>
						<div class="w33" >
	
							<div class="l-flex l-flex-c t-field t-field-pad secondPrn" matTooltip="גורם שולח">
								
								<label>
										גורם שולח
									</label>
									
								<i class="t-sep"></i>
								<span class="t-validation-wrap l-fg1">
									<input type="text" [(ngModel)]="myPat.BranchProviderName2" class="t-field-text w100" />
									<div class="t-validation-message">
										<span>Invalid Doctor ID</span>
									</div>
								</span>
								
							</div>
							
						</div>
					</ng-container>
					
					<div class="w100">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label  matTooltip="הערה">
								Comments
							</label>

							<span class="t-validation-wrap is-sep l-fg1">
								<textarea [(ngModel)]="awlComment" class="t-field-text w100"></textarea>
							</span>
							
						</div>
						
					</div>

					<div class="w100" *ngIf="ls.ExamCodes">

						<div class="l-flex l-flex-c t-field t-field-pad">

							<label>
								Exam Codes
							</label>

							<span class="t-validation-wrap is-sep l-fg1" style="direction: rtl">
								<ng-container *ngFor="let e of ecodeTxt; let i = index">
									<div (dblclick)="removeCode(i)">{{e}}</div>	
								</ng-container>
								<select class="t-select w100" [(ngModel)]="ecode" (change)="addCode()" style="direction:rtl">
									<option value="0"></option>
									<option *ngFor="let opt of ls.ExamCodes" [value]="opt[0]">{{opt[1]}} ({{opt[0]}})</option>
								</select>
							</span>
							
						</div>
						
					</div>
				</div>

				

				

				<button class="new_save" (click)="saveAWL()" *ngIf="(awl || openAWL) && awlTime && (myPat.HMO != 'Leumit' || ! ls.hasLeumit || ! myPat.PRN || PRNVerified)" [ngClass]="awl ? 'lefty' : 'n'"  matTooltip="שמור ברשימה יומית">
					Save To TodayList {{idchanged ? 'and Save Patient Details':''}}
				</button>
				<button class="new_delete" (click)="deleteAWL()" *ngIf="awl && myPat.Status == 'Waiting' && !hasLinkedFormsOrExams" style='float: right'  matTooltip="מחק מרשימה יומית">
					Delete From {{ls.isCardio && ls.category.name == 'doctor' ? 'List' : 'TodayList'}}
				</button>
				<div *ngIf="! myPat.PID || warning" [ngClass]="['patientDetails-warning',warning ? 'warnred':'v']">
					{{warning? warning: 'In case of a new patient it will be kept only after the Save Button is applied!'}}
				</div>

			</div>
		</div>

	</div>


